const ChartOverlay = ({ loading, error, coin }) => {
  if (!loading && !error) return null;

  return (
    <div style={{
      position: 'absolute',
      top: 0, left: 0, right: 0, bottom: 0,
      background: error
        ? 'rgba(22, 26, 30, 0.95)'
        : 'rgba(22, 26, 30, 0.85)',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      color: error ? '#f6465d' : '#0ecb81',
      zIndex: 10,
      fontFamily: 'sans-serif',
      ...(error ? { padding: '20px', textAlign: 'center' } : {}),
    }}>
      <div>
        {error || `Loading ${coin?.name} Real-time Charts...`}
      </div>
    </div>
  );
};

export default ChartOverlay;
